import ko from "knockout";
import resizeObserver from "util/resizeObserver";

declare module "knockout" {
    interface BindingHandlers {
        onResize: ko.BindingHandler<() => void>;
    }
}

ko.bindingHandlers.onResize = {
    init: function (element: Element, valueAccessor) {
        resizeObserver.observe(element, valueAccessor());
        ko.utils.domNodeDisposal.addDisposeCallback(element, () =>
            resizeObserver.unobserve(element)
        );
    },
};
